"use client";

import { useFeatureFlagEnabled } from "./use-feature-flag-enabled";

import {
	CAN_DELETE_OWN_ACCOUNT,
	CHAT_APP,
	CREATE_DRAFT_IN_GMAIL,
	DAILY_BRIEF,
	DEV_TOOLS,
	EMAIL_INBOX,
	ENABLED_INTEGRATIONS,
	ENABLE_IMPERSONATION,
	ENABLE_READ_STATUSES,
	ENABLE_THREAD_LABELS,
	FREE_UNLIMITED_USAGE,
	HARD_PAYWALL,
	LIGHT_MODE,
	RICHTEXT_EDITOR_V2,
	SUMMARY_TOOLTIP,
	USER_CATEGORIES,
	USE_WEB_AGENT,
	WRITING_EXAMPLES,
} from "../lib/flag";

export const useLightMode = (): boolean | undefined =>
	useFeatureFlagEnabled(LIGHT_MODE);

export const useFreeUnlimitedUsage = (): boolean | undefined =>
	useFeatureFlagEnabled(FREE_UNLIMITED_USAGE);

export const useEmailInbox = (): boolean | undefined =>
	useFeatureFlagEnabled(EMAIL_INBOX);

export const useChatApp = (): boolean | undefined =>
	useFeatureFlagEnabled(CHAT_APP);

export const useWebAgent = (): boolean | undefined =>
	useFeatureFlagEnabled(USE_WEB_AGENT);

export const useUserCategories = (): boolean | undefined =>
	useFeatureFlagEnabled(USER_CATEGORIES);

export const useSummaryTooltip = (): boolean | undefined =>
	useFeatureFlagEnabled(SUMMARY_TOOLTIP);

export const useWritingExamples = (): boolean | undefined =>
	useFeatureFlagEnabled(WRITING_EXAMPLES);

export const useCanDeleteOwnAccount = (): boolean | undefined =>
	useFeatureFlagEnabled(CAN_DELETE_OWN_ACCOUNT);

export const useDevTools = (): boolean | undefined =>
	useFeatureFlagEnabled(DEV_TOOLS);

export const useEnableReadStatuses = (): boolean | undefined =>
	useFeatureFlagEnabled(ENABLE_READ_STATUSES);

export const useEnabledIntegrations = (): boolean | undefined =>
	useFeatureFlagEnabled(ENABLED_INTEGRATIONS);

export const useEnableImpersonation = (): boolean | undefined =>
	useFeatureFlagEnabled(ENABLE_IMPERSONATION);

export const useDailyBrief = (): boolean | undefined =>
	useFeatureFlagEnabled(DAILY_BRIEF);

export const useEnableThreadLabels = (): boolean | undefined =>
	useFeatureFlagEnabled(ENABLE_THREAD_LABELS);

export const useCreateDraftInGmail = (): boolean | undefined =>
	useFeatureFlagEnabled(CREATE_DRAFT_IN_GMAIL);

export const useRichtextEditorV2 = (): boolean | undefined =>
	useFeatureFlagEnabled(RICHTEXT_EDITOR_V2);

export const useHardPaywall = (): boolean =>
	(useFeatureFlagEnabled(HARD_PAYWALL) as string | undefined) === "enabled";
